import { getCountryCallingCode } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import { Option } from './CountrySelect.types';

interface Props {
	setSelectedCountry: (country: Option) => void;
	options: Option[];
}

export const FlagDropdown = ({ setSelectedCountry, options }: Props) => {
	const handleSelectCountry = (countryCode: Option) => {
		setSelectedCountry(countryCode);
	};
	return (
		<div className="z-10 bg-white divide-y divide-gray-100 rounded-lg block top-[40px] left-0 absolute shadow-md">
			<div className="py-2 bg-white w-[350px] overflow-scroll overflow-x-hidden z-[9999] h-[200px]">
				<ul>
					{options
						.filter((country) => country.label !== 'International')
						.map((country, index) => (
							<li
								key={`${country.value}_${index}`}
								onClick={() => {
									handleSelectCountry(country);
								}}
								className="gap-1 cursor-pointer inline-flex w-full px-4 py-2  hover:bg-gray-100"
							>
								<div style={{ width: '20px' }}>
									{flags?.[country.value]?.({ title: country.label })}
								</div>
								{country.label}
								{country.value ? `(+${getCountryCallingCode(country.value)})` : ''}
							</li>
						))}
				</ul>
			</div>
		</div>
	);
};
